import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-content',
  templateUrl: './terms-content.component.html',
  styleUrls: ['./terms-content.component.scss']
})
export class TermsContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
